import { getJson } from './httpClient';

/**
 * Single cuisine item as returned by GET /getCuisines.
 * @typedef {Object} Cuisine
 * @property {string} id
 * @property {string} name
 * @property {string} image_url - May be empty when no image is set server-side.
 */

/**
 * Payload inside the API `data` object for cuisines.
 * @typedef {Object} CuisinesData
 * @property {Cuisine[]} cuisines
 * @property {string} [is_logged_in]
 */

/**
 * Full API envelope for GET /getCuisines.
 * @typedef {Object} GetCuisinesResponse
 * @property {boolean} success
 * @property {string} message
 * @property {CuisinesData} data
 */

/**
 * Fetches the public list of cuisines.
 * Endpoint: https://dev.dindinpos.com/api/v1/getCuisines
 *
 * @param {RequestInit} [fetchInit] - e.g. `{ signal }` from AbortController
 * @returns {Promise<{ cuisines: Cuisine[], message: string }>}
 */
export async function fetchCuisines(fetchInit) {
  /** @type {GetCuisinesResponse} */
  const json = await getJson('/getCuisines', fetchInit);

  if (!json.success) {
    throw new Error(json.message || 'Cuisines request was not successful');
  }

  const cuisines = json.data?.cuisines;
  if (!Array.isArray(cuisines)) {
    throw new Error('Unexpected API shape: data.cuisines is not an array');
  }

  return {
    cuisines,
    message: json.message,
  };
}
